export default "__VITE_ASSET__6d0f27a6__"